import React, { Fragment } from 'react';

import PropTypes from 'prop-types';

import './notification-service-overview.css';
import { useTranslation } from 'react-i18next';

const NotificationServiceOverview = (props) => {
  const { t } = useTranslation();
  return (
    <div className={`notification-service-overview-layout216 thq-section-padding ${props.rootClassName} `}>
      <div className='notification-service-overview-max-width thq-section-max-width thq-flex-row'>
        <div className='thq-flex-column'>
          <img
            alt={props.featureImageAlt}
            src={props.featureImageSrc}
            className='notification-service-overview-image1 thq-img-ratio-4-3'
          />
        </div>
        <div className='thq-flex-column notification-service-overview-content'>
          <div className='notification-service-overview-section-title1 thq-flex-column'>
            <h2 className='thq-heading-2'>
              {props.sectionTitle ?? (
                <Fragment>
                  <span className='notification-service-overview-text37'>{t('notificationService.title')}</span>
                </Fragment>
              )}
            </h2>
            <p className='thq-body-large'>
              {props.featureDescription ?? (
                <Fragment>
                  <span className='notification-service-overview-text47'>{t('notificationService.description')}</span>
                </Fragment>
              )}
            </p>
          </div>
          <div className='notification-service-overview-section-title2 thq-flex-column'>
            <h3 className='thq-heading-3 thq-heading-2'>
              {props.sectionTitle1 ?? (
                <Fragment>
                  <span className='notification-service-overview-text36'>{t('notificationService.coverageTitle')}</span>
                </Fragment>
              )}
            </h3>
            <p className='notification-service-overview-text13'>
              {props.heading ?? (
                <Fragment>
                  <span className='notification-service-overview-text45'>{t('notificationService.uaeHeading')}</span>
                </Fragment>
              )}
            </p>
            <p>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px' }}>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇫🇷 {t('countries.france')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇳🇱 {t('countries.netherlands')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇵🇹 {t('countries.portugal')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇮🇹 {t('countries.italy')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇭🇺 {t('countries.hungary')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇨🇭 {t('countries.switzerland')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇦🇹 {t('countries.austria')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇨🇿 {t('countries.czechia')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇬🇷 {t('countries.greece')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇫🇮 {t('countries.finland')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇸🇪 {t('countries.sweden')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇳🇴 {t('countries.norway')}
                </div>
              </div>
            </p>
            <p className='notification-service-overview-text20'>
              {props.heading1 ?? (
                <Fragment>
                  <span className='notification-service-overview-text46'>{t('notificationService.ukHeading')}</span>
                </Fragment>
              )}
            </p>
            <p>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px' }}>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇫🇷 {t('countries.france')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇪🇸 {t('countries.spain')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇩🇪 {t('countries.germany')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇳🇱 {t('countries.netherlands')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇵🇹 {t('countries.portugal')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇮🇹 {t('countries.italy')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇭🇷 {t('countries.hungary')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇧🇪 {t('countries.belgium')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇦🇹 {t('countries.austria')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇨🇿 {t('countries.czechia')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇧🇬 {t('countries.bulgaria')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇲🇹 {t('countries.malta')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇨🇭 {t('countries.switzerland')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇫🇮 {t('countries.finland')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇮🇸 {t('countries.iceland')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇳🇴 {t('countries.norway')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇩🇰 {t('countries.denmark')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇱🇹 {t('countries.lithuania')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇨🇾 {t('countries.cyprus')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇸🇮 {t('countries.slovenia')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇪🇪 {t('countries.estonia')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇭🇷 {t('countries.croatia')}
                </div>
                <div className='notification-service-overview-country' style={{ padding: '8px', width: '100%' }}>
                  🇱🇻 {t('countries.latvia')}
                </div>
              </div>
            </p>
          </div>
          <div className='notification-service-overview-section-title3 thq-flex-column'>
            <h3 className='thq-heading-3 thq-heading-2'>
              {props.sectionTitle11 ?? (
                <Fragment>
                  <span className='notification-service-overview-text38'>{t('notificationService.priceTitle')}</span>
                </Fragment>
              )}
            </h3>
            <p className='thq-body-large'>
              {props.featureDescription11 ?? (
                <Fragment>
                  <span className='notification-service-overview-text52'>
                    {t('notificationService.priceDescription')}
                  </span>
                </Fragment>
              )}
            </p>
          </div>
          <div className='notification-service-overview-actions thq-flex-row'>
            <a
              href='https://t.me/schengen_visa_slot_bot?start=we_02_0000'
              target='_blank'
              rel='noreferrer noopener'
              className='notification-service-overview-button thq-button-filled'
            >
              <span className='thq-body-small'>
                {props.mainAction ?? (
                  <Fragment>
                    <span className='notification-service-overview-text44'>{t('notificationService.subscribe')}</span>
                  </Fragment>
                )}
              </span>
            </a>
          </div>
          <span className='notification-service-overview-text35'>
            {props.text ?? (
              <Fragment>
                <span className='notification-service-overview-text39'>{t('notificationService.disclaimer')}</span>
              </Fragment>
            )}
          </span>
        </div>
      </div>
    </div>
  );
};

NotificationServiceOverview.defaultProps = {
  rootClassName: '',
  sectionTitle1: undefined,
  sectionTitle: undefined,
  sectionTitle11: undefined,
  text: undefined,
  mainAction: undefined,
  heading: undefined,
  featureImageSrc:
    'https://images.unsplash.com/photo-1584091377126-3817650725fc?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDN8fG5vdGlmaWNhdGlvbnxlbnwwfHx8fDE3NTAyMzEzODJ8MA&ixlib=rb-4.1.0&w=1400',
  featureImageAlt: 'Instant Notifications for Schengen Visa Appointments',
  heading1: undefined,
  featureDescription: undefined,
  featureDescription11: undefined,
};

NotificationServiceOverview.propTypes = {
  rootClassName: PropTypes.string,
  sectionTitle1: PropTypes.element,
  sectionTitle: PropTypes.element,
  sectionTitle11: PropTypes.element,
  text: PropTypes.element,
  mainAction: PropTypes.element,
  heading: PropTypes.element,
  featureImageSrc: PropTypes.string,
  featureImageAlt: PropTypes.string,
  heading1: PropTypes.element,
  featureDescription: PropTypes.element,
  featureDescription11: PropTypes.element,
};

export default NotificationServiceOverview;
